import { CircularProgress, Stack, Typography } from "@mui/material";
import { ProjectUpdate } from "../../hooks/useUpdates";
import { UpdateCard } from "./UpdateCard";

interface UpdatesListProps {
  updates: ProjectUpdate[];
  loading: boolean;
  error: string | null;
  canDelete: boolean;
  onDelete?: (updateId: string) => Promise<void>;
}

export function UpdatesList({
  updates,
  loading,
  error,
  canDelete,
  onDelete,
}: UpdatesListProps) {
  if (loading) {
    return (
      <Stack alignItems="center" sx={{ py: 4 }}>
        <CircularProgress size={24} />
      </Stack>
    );
  }

  if (error) {
    return (
      <Typography variant="body2" color="error">
        {error}
      </Typography>
    );
  }

  if (updates.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No updates yet.
      </Typography>
    );
  }

  return (
    <Stack spacing={1.5}>
      {updates.map((update) => (
        <UpdateCard
          key={update.id}
          update={update}
          canDelete={canDelete}
          onDelete={onDelete}
        />
      ))}
    </Stack>
  );
}
